class MainSlider extends HTMLElement {
  constructor() {
    super();

    this.initSlider();
  }

  initSlider() {
    const swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
    });
  }
}

customElements.define("main-slider", MainSlider);
